import React, { useContext, useEffect } from "react";
import { Button, FormControl, InputGroup, Offcanvas } from "react-bootstrap";
import { CartContext } from "../../../contexts/CartContext";

import OffCartCanvasCard from "../OffCanvasCard/OffCartCanvasCard";
import { Link, useNavigate } from "react-router-dom";
import { dispatch } from "../../../redux/store";
import { useSelector } from "react-redux";
import {
  deletecart,
  getAllcarts,
  updateCart,
} from "../../../redux/slices/Cart";
import Swal from "sweetalert2";
import useAuth from "../../../hooks/useAuth";
import { currencySymbol, useClickOutside } from "../../../utils/helpers";
import "./cart.css";
import CurrencyFormat from "react-currency-format";
import { useState } from "react";
export const CartShow = ({ onHideCart, placement, showCart, ref }) => {
  const navigate = useNavigate();
  const [cartList, setCartList] = useContext(CartContext);
  const { subtotal, carts, CartCount } = useSelector((state) => state.cart);
  
  const [outOfStock, setOutOfStock] = useState(false);

  const { user } = useAuth();

  let domNode = useClickOutside(() => {
    onHideCart(false);
  });

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger mx-2",
      confirmButton: "btn btn-primary mx-2",
    },
    buttonsStyling: false,
  });

  const removeItem = (product) => {
    // console.log({subtotal});
    // console.log({product});
    let CartTotal =
      parseFloat(subtotal) -
      parseFloat(product.price) * parseFloat(product.qty);
    // console.log({CartTotal});
    const data = {
      cart_item_id: product.id,
      total_price: CartTotal,
      cart_id: product.cart_id,
    };

    swalWithBootstrapButtons
      .fire({
        icon: "question",
        text: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "delete",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(deletecart(data))
            .unwrap()
            .then((res) => {
              // console.log("res", res);
              if (res.success === true) {
                const removeThenCartItem = cartList.filter(
                  (listItem) => listItem?.id !== product.id
                );
                setCartList([...removeThenCartItem]);
                Swal.fire({
                  icon: "success",
                  text: `${res.message}`,
                });
              } else {
                Swal.fire({
                  icon: "error",
                  text: `${res.message}`,
                });
              }
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                text: `${err.message}`,
              });
            });
        } else {
          return;
        }
      });
  };

  //   Increase Quantity
  const increaseQuantity = (item) => {
    //
    // if(item.product.available_qty != null){
    //   if (qty_ref.current.value <= item.available_qty) {
    //     return;
    //   }
    // }
    
    let CartTotal = subtotal + parseInt(item.price);
    let quantity = parseInt(item.qty) + 1;
    if (item?.product_variant?.continue_selling === 0 && (item?.product_variant?.available_qty < quantity)) {
      Swal.fire({
        icon : "warning",
        text : "Sorry, Entered quantity is not available."
      })
      return;
    }
    const payload = {
      cart_id: item.cart_id,
      total_price: CartTotal,
      id: item.id,
      qty: quantity,
    };

    dispatch(updateCart(payload));
  };

  //   Decrese Quantity
  const decreaseQuantity = (item) => {
    // if(item.product.available_qty != null){
    //   if (qty_ref.current.value == item.available_qty) {
    //     return;
    //   }
    // }
    if (parseInt(item.qty) > 1) {
      let quantity = parseInt(item.qty) - 1;
      let CartTotal = subtotal - parseInt(item.price);
      const payload = {
        cart_id: item.cart_id,
        total_price: CartTotal,
        id: item.id,
        qty: quantity,
      };
      dispatch(updateCart(payload));
    }
  };

  useEffect(() => {
    if (user) {
      if (user.user_type === "3") {
        dispatch(getAllcarts());
      }
    }
  }, []);

  useEffect(() => {
    if (user) {
      if (user.user_type === "3") {
        dispatch(getAllcarts());
      }
    }
  }, [CartCount]);

  const handleProceedToCheckout = () => {
    onHideCart(false);
    navigate("/cart");
  };
  // console.log({carts});
  return (
    <Offcanvas
      className={"allOffcanvas"}
      show={showCart}
      onHide={onHideCart}
      placement={placement}
    >
      <Offcanvas.Header closeButton className="offcanvas-header border-bottom">
        <Offcanvas.Title>
          <h5 className="offcanvas-title text-primary" id="CartOffcanvasLabel">
            {/* <i className="fas fa-dolly me-2"></i> */}
            <i className="fas fa-shopping-cart me-2"></i>
            Cart ({cartList?.length})
          </h5>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body ref={domNode} className="offcanvas-body">
        {cartList.length <= 0 ? (
          <h6 className="text-center">No item in cart</h6>
        ) : (
          ""
        )}
        <ul className="cart-list">
          {cartList?.map((item) =>
            item ? (
              <OffCartCanvasCard
                item={item}
                removeItem={() => removeItem(item)}
                key={item.id}
                decreaseQuantity={decreaseQuantity}
                increaseQuantity={increaseQuantity}
              />
            ) : (
              ""
            )
          )}
        </ul>
        <div className="cart-footer">
          <button
            disabled={cartList?.length === 0}
            style={{ opacity: cartList?.length === 0 ? "0.6" : "1" }}
            className="cart-checkout-btn d-flex align-items-center w-100"
            onClick={handleProceedToCheckout}
          >
            <span className="checkout-label">View Cart</span>
            <span className="checkout-price">
              {subtotal > 0 ?  (
                <>
                {currencySymbol()}
                <CurrencyFormat
                  value={subtotal}
                  displayType={"text"}
                  thousandSeparator={true}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  />
                  </>
              ) : 
              <>
              {currencySymbol()}
                0
              </>
            }
            </span>
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
